import { useSelector } from 'react-redux'

import routes from '@tabeeb/routes'
import { getShowBulkImport } from '@tabeeb/modules/bulkImports/selectors'

import NavbarTab from '../NavbarTab'

const BulkImportTab = ({ ...rest }) => {
  const display = useSelector(getShowBulkImport)

  const props = {
    item: {
      label: 'Bulk import',
      to: routes.bulkImports,
    },
    display,
    ...rest,
  }

  return <NavbarTab {...props} />
}

export default BulkImportTab
